import axios from 'axios';
import store from '@/store/store';

const baseUrl = '/sdk/wiki/api/';
// 小游戏SDK渠道管理端cgi接口
const MINI_GAME_SDK_MANAGE_BASE_URL = 'https://q.qq.com/channel/manage/cgi/channel/';


const handleEnv = (result: any = {}) => {
  const { env = '' } = result.data || {};
  if (env) {
    store.commit('setCurEnv', env);
  }
};

const commonRequest = async (url, payload) => {
  const result = await axios.post(url, payload);
  handleEnv(result);
  return result;
};

export const queryWiki = async (payload: any) => {
  const result = await commonRequest(`${baseUrl}getWikiSpace`, payload);
  return result.data?.data?.result;
};

export const queryCategory = async (payload: any) => {
  const result = await commonRequest(`${baseUrl}getWikiCatalogue`, payload);
  return result.data?.data?.data?.list || [];
};

export const queryDocInfo = async (payload: any) => {
  const result = await commonRequest(`${baseUrl}getDocInfo`, payload);
  return result.data?.data?.data?.body;
};

export const getLatestCdnUrl = async (payload: any) => {
  const result = await commonRequest(`${baseUrl}getLatestCdnUrl`, payload);
  return result.data?.url;
};

export const fetchJsonp = (url, document) => {
  const body = document.getElementsByTagName('body')[0];
  //插入一个script
  const script = document.createElement('script');
  script.setAttribute('src', url);
  body.appendChild(script);
};

// 获取当前用户在小游戏SDK渠道管理端有权限的渠道列表
export const getChannelList = async(payload: any) => {
  const result = await axios.get(`${MINI_GAME_SDK_MANAGE_BASE_URL}getChannelList`, payload);
  handleEnv(result);
  return result.data;
}

// 获取当前用户是否有指定权限
export const checkAuth = async (payload: any) => {
  const result = await commonRequest(`${MINI_GAME_SDK_MANAGE_BASE_URL}checkAuth`, payload);
  return result.data;
}
